module.exports = "<div class=rm-fares-optimizer-dashboard-panel><div class=row><div class=col-xs-12><h1 class=page-title>Dashboard</h1></div></div></div>";